'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _responseCodes = require('helpers/responseCodes');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _strings = require('helpers/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./RecipientsImportReport.scss');

var RecipientsImportReport = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientsImportReport, _PureComponent);

  function RecipientsImportReport() {
    (0, _classCallCheck3.default)(this, RecipientsImportReport);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientsImportReport.__proto__ || (0, _getPrototypeOf2.default)(RecipientsImportReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientsImportReport, [{
    key: 'getExistingRecipients',
    value: function getExistingRecipients() {
      var _errors;

      var data = this.props.data;
      var t = this.context.t;

      var _t = t;
      var recipients = [];

      var errors = (_errors = {}, (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.invalidContact, t('Invalid email address')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.emailExists, t('Contact already exists')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.recipientExists, t('Contact already exists')), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.groupEmailExists, t('Contact exists in group')), _errors);

      data.map(function (recipient) {
        if (errors[recipient.result]) {
          recipients.push((0, _extends3.default)({}, recipient, { uuid: (0, _uuid2.default)(), errorMessage: _t(recipient.info) || errors[recipient.result] }));
        }
      });

      return recipients;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showHeader = _props.showHeader,
          showSubHeader = _props.showSubHeader,
          className = _props.className;
      var t = this.context.t;

      var existingRecipients = this.getExistingRecipients();

      if (!existingRecipients.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        showHeader && _react2.default.createElement(
          'div',
          { className: styles.header },
          t('Contacts import report')
        ),
        showSubHeader && _react2.default.createElement(
          'div',
          { className: styles.subheader },
          t('Could not add the following contacts'),
          ':'
        ),
        existingRecipients.map(function (recipient) {
          return _react2.default.createElement(
            'li',
            { key: recipient.uuid, className: styles.row },
            _react2.default.createElement(
              'span',
              { className: styles.name },
              (0, _strings.concat)(' ', recipient.name, recipient.surname),
              ' (',
              recipient.userEmail || recipient.email,
              ')'
            ),
            '-',
            _react2.default.createElement(
              'span',
              { className: styles.error },
              recipient.errorMessage
            )
          );
        })
      );
    }
  }]);
  return RecipientsImportReport;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.array,
  showHeader: _propTypes2.default.bool,
  showSubHeader: _propTypes2.default.bool
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  data: []
}, _temp);
exports.default = RecipientsImportReport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/RecipientsImportReport/RecipientsImportReport.js
// module id = 2201
// module chunks = 1